import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { Paragraph4 } from '@r1-frontend/ui-react/components/typography/paragraph';
import SubscriptionCost from '@r1-frontend/ui-react/organisms/TariffSubscription/Cost/Cost';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

const StyledSubscriptionCost = styled(SubscriptionCost)`
    // This is an experimental thing from designers... Sorry guys, again...
    // I did not use Paragraph 4 and Paragraph 5 in chain with use MatchMedia because this way is the more simple. 
    @media (max-width: ${wideBreakpoints.mobile}) {
        ${Paragraph4} {
            ${FONTS.XXS};
        }
    }
`;

export default StyledSubscriptionCost;
